import { Form, BaseModel, OneColumnLayout, Entry, EntryTypes, CardMode, Resource } from '@ngx-resource-toolkit/core';

const cssLabel = 'col-xs-5';
const normalCss = {
    group: 'col-xs-12',
    label: cssLabel,
    input: 'col-xs-7'
};

@Form({
    'consult': { // Mode consultation
        layout: OneColumnLayout,
    },
    'edit': { // Mode modification (création/modification)
        layout: OneColumnLayout,
    }
})
export class ExamenMentionModel extends BaseModel {
    @Entry({
        base: {

        },
        'consult': {
            css: {
                group: 'col-xs-12',
                label: cssLabel,
                input: 'col-xs-7'
            },
            type: EntryTypes.STATIC,
            transform: (value, row) => (row) ? ((row.libelleCourt) ? row.libelleCourt : row.libelle) : value,
        },
        'table': {
            type: EntryTypes.STATIC,
            transform: (value, row) => (row) ? ((row.libelleCourt) ? row.libelleCourt : row.libelle) : value,
        },
        'edit': {
            // type: EntryTypes.RADIO, // C'était des boutons radio dans Flex :
            // affichage libellé court avec une légende en dessous contenant le libellé long
            css: normalCss,
            type: EntryTypes.SELECT
        },
    })
    id: number;
    groupe: number; // Groupe de mention (on peut créer plusieurs groupes pour avoir des listes différentes)
    @Entry({
        base: {
            css: {
                group: 'col-xs-12',
                label: cssLabel,
                input: 'col-xs-6'
            },
        },
        'consult': {},
        'table': {},
        'edit': {},
    })
    libelleCourt: string;
    libelle: string;
    activated: boolean; // active ?
    ordre: number; // ordre de tri
    noteMinimum: number; // Note minimum pour avoir la mention
    isChangementNiveau: boolean; // Indique si cette mention permet un changement de niveau

	/**
	 *
	 * @param fields
	 * @param indexNoteMention : index de la note mention, -1 pour la mention calculée, -2 pour la mention du jury (id dans le champ jury de examen)
	 * @param typeNotation
	 * @param nomChampMention
	 */
    constructor() {
        // fields: any, indexNoteMention: number, typeNotation: any, nomChampMention: string, libelleMention?: string, groupeMention?: number
        super();
		/*this.initData(fields);
		this.initModele(indexNoteMention, typeNotation, nomChampMention, libelleMention);*/
    }

    initData(fields: any) {
        if (fields) {
            Object.assign(this, fields);
        }
    }

    // parent permet d'ajouter des éléments sur le parent pour gérer le cas de l'auto-table qui ne gère pas les sous-types
    initModele(indexNoteMention: number, typeNotation: any, nomChampMention: string, libelleMention?: string, parent?: any, groupeMention?: number) {
        // console.log({ ou: 'ExamenMentionModel.initModele', indexNoteMention, typeNotation, nomChampMention, libelleMention, groupeMention });
        // modeAutre est en fait un mode edit pour les table
        const listeOptions = [];
        const listeOptionsParent = []; // Le format est différent lorsqu'on met la liste dans le parent car il faut intégrer l'objet ExamenMentionModel dans son ensemble
        const entryEdit = this.getEntry('edit', 'id');
        const entryConsult = this.getEntry('consult', 'id');
        // const entryTable = this.getEntry('table', 'id');

        if (!entryEdit) {
            console.log('entryEdit inconnu', entryEdit);
        }
        if (!entryConsult) {
            console.log('entryConsult inconnu', entryConsult);
        }
        let libelleChamp = '';
        let estMentionPresente = false;
        if (indexNoteMention === -1) { // Cas mention calculée
            libelleChamp = 'Mention';
            estMentionPresente = true;
            entryEdit.hidden = true; // masqué modification car elle est calculée lors de l'enregistrement
        } else if (indexNoteMention === -2) { // Cas mention du jury
            libelleChamp = 'Mention';
            estMentionPresente = true;
            entryEdit.hidden = false;
            if (libelleMention) {
                // this.registerEntryDynamicProperty(['consult'], 'libelleCourt', 'value', libelleMention);
                this.libelleCourt = libelleMention;
            }
        } else { // Mentions 1, 2, 3...
            const nomChampMentionLibelle = 'mention_' + indexNoteMention + '_libelle';
            libelleChamp = (typeNotation[nomChampMentionLibelle]) ? typeNotation[nomChampMentionLibelle] : '';
            estMentionPresente = (typeNotation[nomChampMention] != null && typeNotation[nomChampMention] != 0);
            entryEdit.hidden = !estMentionPresente;
        }
        groupeMention = groupeMention ? groupeMention : +typeNotation[nomChampMention]; // Détermine la collection d'options possibles
        // console.log('estMentionPresente', nomChampMention, estMentionPresente);
        entryConsult.hidden = !estMentionPresente;
        if (estMentionPresente) {
            // console.log('estMentionPresente');
            // Note mention présente
            // this.libelleCourt = libelleChamp; NON ici on initialise le modèle, pas les données
            entryEdit.label = libelleChamp;
            entryConsult.label = libelleChamp;
            // entryTable.label = libelleChamp;

            if (typeNotation.listeMentions && typeNotation.listeMentions[groupeMention]) {
                // Ajout d'une mention vide en premier pour pouvoir supprimer une mention
                listeOptions.push({
                    value: null,
                    label: '' // libelleCourt
                });
                listeOptionsParent.push({
                    value: null,
                    label: '' // libelleCourt
                });
                typeNotation.listeMentions[groupeMention].forEach(element => {
                    listeOptions.push({
                        value: element.id,
                        label: element.libelle // libelleCourt
                    });
                    listeOptionsParent.push({
                        value: element,
                        label: element.libelle // libelleCourt
                    });
                });
                console.log(listeOptions);
                this.registerEntryDynamicProperty(['edit'], 'id', 'options', listeOptions);
                console.log(this.getEntries('edit'));
                console.log({ qui: 'parent', parent, entriesParentEdit: parent.getEntries('edit')});
                if (parent) {
                    if (indexNoteMention === -2) { // Cas mention du jury
                        /*const entryMention = parent.getEntry('edit', nomChampMention);
                        if (entryMention) {
                            // entryMention.label = libelleChamp;
                            // entryMention.nested = false;
                            parent.registerEntryDynamicProperty(['edit'], nomChampMention, 'label', libelleChamp);
                            parent.registerEntryDynamicProperty(['edit'], nomChampMention, 'nested', false);
                            parent.registerEntryDynamicProperty(['edit'], nomChampMention, 'options', listeOptionsParent);
                            console.log('parent entries mis a jour');
                        }*/
                    } else {
                        const entryTable = parent.getEntry('table', nomChampMention);
                        if (entryTable) {
                            entryTable.label = libelleChamp;
                            parent.registerEntryDynamicProperty(['table'], nomChampMention, 'options', listeOptionsParent);
                        }
                    }
                }
                console.log({ qui: 'parent', parent, entriesParentEdit: parent.getEntries('edit') });
                // this.registerEntryDynamicProperty(['table'], 'id', 'options', listeOptions)
            }
        }
    }
}


// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/examen/models/examen-mention.model.ts